import "./training-listing-page.scss";
